(function () {
  'use strict';
  angular
    .module('MW.ContactManager.TrustFilter', [])
      .filter('trusted', function ($sce) {
      return function (html) {
        return $sce.trustAsHtml(html);
      };
    });
}());